var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{staticClass:"d-flex justify-center align-center flex-column"},[_c('project-form'),_c('project'),_c('project-subscription'),_c('tracks-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }